<footer>
    <div class="text-center">
        &copy; Todos los derechos reservados  mipesoideal.com 2003
        <a href="https://servpc.cl" target="_blank"> "Desarrollado por Servpc SpA"</a>
    </div>
</footer>